import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type ExternalIcalAdapter from 'uplisting-frontend/adapters/external-ical';
import { ExternalIcalValidation } from 'uplisting-frontend/validations';

export default class ExternalIcalRepositoryService extends BaseRepositoryService<
  ModelRegistry['external-ical']
> {
  recordName = 'external-ical';
  implementMethods = ['buildChangeset'];

  validation = ExternalIcalValidation;

  public async retry(
    externalIcal: ModelRegistry['external-ical'],
  ): Promise<void> {
    try {
      const adapter = this.store.adapterFor(
        'external-ical',
      ) as ExternalIcalAdapter;
      const payload = await adapter.retry(externalIcal.id);

      this.store.pushPayload(payload);
    } catch (err) {
      this.sentry.captureException(err, {
        tags: { repository: this.recordName, operation: 'retry' },
      });

      throw err;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/external-ical': ExternalIcalRepositoryService;
  }
}
